// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-components-HxTaxBureau-components-TaxForm-__index__wrapper--3FGt_","title":"src-components-HxTaxBureau-components-TaxForm-__index__title--1vvmX"};